// *******************************************************************************
// 1.0 - Form Validation
// *******************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const editProfileForm = document.querySelector('.edit-profile-form');
  const editProfileFormEle = document.getElementById('edit-profile-form');
  if (editProfileFormEle) {
    const fv = FormValidation.formValidation(editProfileFormEle, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input , .checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input , .checkbox');
        FormValidation.utils.classSet(container, { 'is-validation-failed': !e.valid && value === '' });
      })
      .on('core.form.valid', () => {
        editProfileForm.classList.add('show-thankyou');
      });
  }
});
